import type { FProductPageTemplateProps } from '@/components/templates/FProductPageTemplate.vue';

export function mapApiDataToProductPage(
  productPageRawData: StrapiResponseData<ProductPageContentType> | undefined
): Pick<FProductPageTemplateProps, 'faqItems'> {
  const productPageDataAttributes = productPageRawData?.attributes;

  return {
    faqItems: (productPageDataAttributes?.faq_items ?? []).map(faqItem => ({
      title: faqItem.title,
      content: faqItem.content,
    })),
  };
}
